import React from "react";
import styled from "styled-components";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { MediaType } from "../../../schemas/Media";
import { MediaImage } from "../../../components/Media";
const _Backdrop = ({ background, foreground, ...BackdropProps }) => {
    return (React.createElement(Backdrop, { ...BackdropProps },
        React.createElement(BackdropBackground, null, background?.type === MediaType.IMAGE && (React.createElement(MediaImage, { "data-testid": "backdrop-background-image", fit: "height", media: background, role: "presentation" }))),
        React.createElement(BackdropForeground, null, foreground?.type === MediaType.IMAGE && (React.createElement(MediaImage, { "data-testid": "backdrop-foreground-image", fit: "height", media: foreground, role: "presentation" })))));
};
export const MastheadBackdrop = styled(_Backdrop) ``;
//# sourceMappingURL=Backdrop.js.map